import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const PatternInspectorScreen = lazy(
  () => import('~/features/item-setup/pages/pattern-inspector-screen'),
);

// Which calibration step launched the inspector — drives the "Go Back" target.
const searchSchema = z.object({
  from: z.enum(['quality-report', 'enrichment-overview']).catch('quality-report'),
});

export const Route = createFileRoute('/_authenticated/_tenant/item-setup/pattern-inspector')({
  validateSearch: searchSchema,
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <PatternInspectorScreen />
    </Suspense>
  ),
});
